import { useLang } from '@/lib/LanguageContext';
import { Link } from 'react-router-dom';

export default function FinalCTA() {
  const { t } = useLang();
  return (
    <section className="relative py-28 px-6 lg:px-8 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-primary/5 to-transparent pointer-events-none" />
      <div className="relative max-w-4xl mx-auto text-center">
        <p className="text-sm font-inter tracking-[0.3em] uppercase text-primary">{t('Have a difficult problem worth solving?')}</p>
        <h2 className="mt-4 font-inter font-black text-4xl md:text-6xl tracking-[-0.03em] text-foreground">{t("Let's build it.")}</h2>
        <p className="mt-6 max-w-2xl mx-auto text-muted-foreground font-inter font-light leading-relaxed">
          {t('From AI and software to cybersecurity and emerging technology, Jotunheims helps ambitious teams turn complex ideas into working products.')}
        </p>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link to="/contact" className="px-8 py-4 bg-primary text-primary-foreground font-inter font-semibold text-sm tracking-wider uppercase rounded-lg hover:bg-primary/90 transition-all">{t('Get a Quote')} →</Link>
          <a href="#ventures" onClick={(e) => { const el = document.querySelector('#ventures'); if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth' }); } }} className="px-8 py-4 border border-border text-foreground font-inter font-medium text-sm tracking-wider uppercase rounded-lg hover:border-primary/50 hover:text-primary transition-all">{t('Explore Our Ventures')} →</a>
        </div>
      </div>
    </section>
  );
}